import React, { useState } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Drawer, DrawerList } from '../components';
import './style.scss';
import { Logout } from '../redux/actions/CommonActions';
import LogoutConfirm from '../components/atoms/LogoutConfirmBox/container';
import { Elements, StripeProvider } from 'react-stripe-elements';
import MessageModal from '../components/molecules/MessageModal';

const { ROUTE_CONSTANTS } = require(`../shared/constants/Route`);

const {
  MainDashboard,
  TopicScreen,
  SubTopicScreen,
  QuestionScreen,
  VideoScreen,
  SimulatedTestInfo,
  FlashCardsScreen,
  DisplayFlashCardsScreen,
  Achievements,
  Challenges,
  ChangePassword,
  CourseManual,
  Leaderboard,
  TestResults,
  TestSpeed,
  Tutorial,
  PurchaseScreen,
  SimulatedTestQuestions,
} = require(`../Screens`);

const PurchaseModalScreen = ({ history }) => {
  const hidePurchaseModal = () => {
    history.goBack();
  };

  return (
    <MessageModal
      icon='purchase.png'
      title='Purchase the App'
      message='You need to purchase the app from dashboard in order to process further.'
      color={'#fff'}
      callback={hidePurchaseModal}
      render={() => {
        return (
          <button
            style={{
              background: '#fff',
              border: '1.25px solid #7ebf41',
              color: '#7ebf41',
              padding: '.65rem 2rem',
              borderRadius: '5px',
              fontWeight: 'bolder',
              marginTop: '1rem',
              cursor: 'pointer',
            }}
            onClick={() => {
              history.replace(ROUTE_CONSTANTS.PURCHASE_P2P);
            }}
          >
            Okay
          </button>
        );
      }}
    />
  );
};

const SuperAdminRouter = ({ purchaseStatus, challengeStatus }) => {
  const [showDrawer, toggleDrawer] = useState(false);
  let history = useHistory();

  return (
    // live  "pk_live_TIczmo1kNehMkouK0OnqzWIE"
    // test "pk_test_QyHPyOxXg00RMjrLzKQVZili"
    <StripeProvider apiKey={'pk_test_QyHPyOxXg00RMjrLzKQVZili'}>
      <Elements>
        <div className='container-fluid'>
          <Drawer
            onClick={(path) => {
              toggleDrawer(false);
              history.push(path);
            }}
            open={showDrawer}
            toggleDrawer={(state) => toggleDrawer(state)}
          />
          <div className='drawer_menu'>
            <DrawerList onClick={(path) => history.push(path)}/>
          </div>
          <div className='rightsidebar'>
            <div className='panel-box'>
              <div className='mob-header d-flex align-items-center justify-content-between'>
                <div
                  onClick={() => toggleDrawer(!showDrawer)}
                  className='hamburger-logo'
                >
                  <img
                    src={require(`../Assets/Images/Icons/hamburger_icon.svg`)}
                    alt='Prep2Pass'
                    className='img-fluid'
                  />
                </div>

                <LogoutConfirm text={'Log Out'}/>
              </div>

              <div className='navbar-header d-flex align-items-center justify-content-end'>
                <LogoutConfirm text={'Log Out'}/>
              </div>
              <Switch>
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.ROOT}`}
                  component={FlashCardsScreen}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.DASHBOARD}`}
                  component={MainDashboard}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.QUESTIONS}`}
                  component={TopicScreen}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.SUBTOPIC}`}
                  component={SubTopicScreen}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.TOPIC_QUESTIONS}`}
                  component={QuestionScreen}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.VIDEOS}`}
                  render={(props) =>
                    purchaseStatus ? (
                      <VideoScreen {...props} />
                    ) : (
                      <PurchaseModalScreen {...props} />
                    )
                  }
                  // component={VideoScreen}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.SIMULATDED_TESTS}`}
                  render={(props) =>
                    purchaseStatus ? (
                      <SimulatedTestInfo {...props} />
                    ) : (
                      <PurchaseModalScreen {...props} />
                    )
                  }
                  //component={SimulatedTestInfo}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.SIMULATDED_TESTS_QUESTIONS}`}
                  render={(props) =>
                    challengeStatus || purchaseStatus ? (
                      <SimulatedTestQuestions {...props} />
                    ) : (
                      <PurchaseModalScreen {...props} />
                    )
                  }
                  //component={SimulatedTestQuestions}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.DISPLAY_FLASH}`}
                  component={DisplayFlashCardsScreen}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.DASHBOARD_SIMULATED_TEST}`}
                  component={TestResults}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.LEADERBOARD}`}
                  component={Leaderboard}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.ACHIEVEMENTS}`}
                  component={Achievements}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.CHALLENGES}`}
                  component={Challenges}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.COURSE_MANUAL}`}
                  component={CourseManual}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.TEST_SPEED}`}
                  component={TestSpeed}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.TUTORIAL}`}
                  component={Tutorial}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.PURCHASE_P2P}`}
                  component={PurchaseScreen}
                />
                <Route
                  exact
                  path={`${ROUTE_CONSTANTS.CHANGE_PASSWORD}`}
                  component={ChangePassword}
                />
                <Redirect to={ROUTE_CONSTANTS.ROOT}/>
              </Switch>
            </div>
          </div>
        </div>
      </Elements>
    </StripeProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    purchaseStatus: state.CommonReducer.purchaseStatus,
    challengeStatus: state.ChallengeReducer.challengeStatus,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    Logout: () => dispatch(Logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdminRouter);
